// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-a604f6b2]{display:none}.notifications[data-v-a604f6b2]{align-items:flex-end;display:flex;flex-direction:column;justify-content:flex-start;position:fixed;right:20px;top:20px;z-index:999}@media(max-width:767px){.notifications[data-v-a604f6b2]{left:20px;width:auto}}.notifications .notification[data-v-a604f6b2]:not(:first-child){margin-top:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
